import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { ssApiService } from '../../../services/ss-api.service';
import { ResetPasswordRequest } from '../../../models/ss-api/requests/reset.password.request';
import { SweetAlertService } from 'ng2-cli-sweetalert2';

@Component({
    selector: 'forgot-password',
    templateUrl: './forgot-password-form.component.html',
})
export class ForgotPasswordFormComponent implements OnInit {
    email: string;

    @Output('onCancel') onCancel  = new EventEmitter();

    constructor(private api: ssApiService, private sweetAlert: SweetAlertService) {

    }

    ngOnInit() {
        this.email = localStorage.getItem('crm_Email');

        if (!this.email) {
            this.email = '';
        }
    }

    ResetPassword() {
        let request: ResetPasswordRequest = {
            Email: this.email
        }
        let disposable = this.api.ResetPassword(request).subscribe(response => {
            if (response.Result) {
                this.sweetAlert.swal({
                    type: 'success',
                    title: 'Password Reset Successful',
                    text: 'Please check your email.'
                }).then( () => {
                    this.Cancel()
                }, () => {
                    this.Cancel()
                })
            } else {
                this.sweetAlert.swal({
                    type: 'error',
                    title: 'Error',
                    text: response.Message
                }).then( () => {}, () => {} )
            }
            disposable.unsubscribe();
        })
    }

    public Cancel() {
        this.onCancel.emit();
    }

}
